import React from "react";
import { cn } from "../../lib/utils";

function StepGroup({ className, children, id, ref, ...props }) {
  return (
    <div
      ref={ref}
      id={id}
      className={cn("flex flex-col gap-0.5", className)}
      {...props}
    >
      {children}
    </div>
  );
}

function Step({ className, active, completed, onClick, children, isGroup, ref, ...props }) {
  return (
    <div
      ref={ref}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={onClick ? (e) => e.key === "Enter" && onClick(e) : undefined}
      className={cn(
        "flex items-start px-3 py-2 text-sm transition-colors rounded-lg",
        isGroup && "font-semibold text-xs uppercase tracking-wide text-primary-900/70 cursor-pointer hover:text-primary-900 mt-2",
        !isGroup && active && "border-l-2 border-primary-900 bg-primary-900/8 text-primary-900 font-semibold rounded-l-none",
        !isGroup && !active && completed && "text-primary-900 hover:bg-primary-900/10 cursor-pointer",
        !isGroup && !active && !completed && "text-gray-400 cursor-default",
        onClick && !isGroup && !active && "cursor-pointer",
        className
      )}
      data-testid={isGroup ? "step-group" : "step-item"}
      {...props}
    >
      {children}
    </div>
  );
}

const StepContent = ({ children, className, ...props }) => (
  <div className={cn("flex-1", className)} {...props}>{children}</div>
);

const StepTitle = ({ children, className, onClick, style, ...props }) => (
  <div
    className={cn("leading-snug", className)}
    onClick={onClick}
    style={style}
    {...props}
  >
    {children}
  </div>
);

export { StepGroup, Step, StepContent, StepTitle };
